import License from "../components/Licenses/License";
import { licences } from "../endpoints";
import useFetch from "../hooks/useFetch";
import { useSearchBar } from "../hooks/search";
import { useClickFilter } from "../hooks/filtering";

interface data {
  name: string;
  vendor: string;
  client: string;
  term: string;
  start: string;
  end: string;
  Buy_price_per: string;
  sell_price_per: string;
  Buy_price_total: string;
  sell_price_total: string;
  margin: string;
  amount: string;
}

const LicensesLayout = () => {
  const { data, loading } = useFetch<data>(licences);

  const {
    searchEntry,
    setSearchEntry,

    setIsSearchFocused,

    shouldShowFilters,
    searchRef,
    getFilteredSearchProjects,
  } = useSearchBar(data);

  const {
    amountSort,
    toggleAmountSort,

    customerSort,
    toggleCustomerSort,

    clientSort,
    toggleClientSort,

    vendorSort,
    toggleVendorSort,

    getArrow,
    getFilteredData,
  } = useClickFilter();

  // Combine search and click filters
  const getFilteredAndSortedData = () => {
    if (!data) return [];
    
    const searchFiltered = getFilteredSearchProjects();
    
    return getFilteredData(searchFiltered);
  };

  // const handleFilterChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
  //   setFilter(e.target.value);
  // };

  // const getFilteredLicenses = () => {
  //   let filteredLicenses = [...data];
  //   switch (filter) {
  //     case "Aantal hoog - laag":
  //       filteredLicenses.sort(
  //         (a, b) => parseFloat(b.amount) - parseFloat(a.amount)
  //       );
  //       break;
  //     case "Aantal laag - hoog":
  //       filteredLicenses.sort(
  //         (a, b) => parseFloat(a.amount) - parseFloat(b.amount)
  //       );
  //       break;
  //     case "Naam A - Z":
  //       filteredLicenses.sort((a, b) => a.name.localeCompare(b.name));
  //       break;
  //     case "Naam Z - A":
  //       filteredLicenses.sort((a, b) => b.name.localeCompare(a.name));
  //       break;
  //     case "Klant A - Z":
  //       filteredLicenses.sort((a, b) => a.client.localeCompare(b.client));
  //       break;
  //     case "Klant Z - A":
  //       filteredLicenses.sort((a, b) => b.client.localeCompare(a.client));
  //       break;
  //     case "Maandelijks":
  //       filteredLicenses = filteredLicenses.filter(
  //         (license) =>
  //           license.term === "Monthly" || license.term === "Month-to-Month"
  //       );
  //       break;
  //     case "Jaarlijks":
  //       filteredLicenses = filteredLicenses.filter(
  //         (license) => license.term === "Annual" || license.term === "1 Year"
  //       );
  //       break;
  //     case "Margin laag - hoog":
  //       filteredLicenses.sort(
  //         (a, b) => parseFloat(a.margin) - parseFloat(b.margin)
  //       );
  //       break;
  //     case "Margin hoog - laag":
  //       filteredLicenses.sort(
  //         (a, b) => parseFloat(b.margin) - parseFloat(a.margin)
  //       );
  //       break;
  //     default:
  //       break;
  //   }
  //   return filteredLicenses;
  // };

  return (
    <div className="overflow-hidden w-full">
      {/* Header */}
      <div>
        <div className="flex justify-between">
          {/* Header Text */}
          <div>
            <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center">
              <h1 className="font-bold text-3xl sm:text-4xl">
                {loading ? (
                  <span className="text-gray-400">Licenties laden...</span>
                ) : (
                  `Licenties`
                )}
              </h1>
            </div>
            <p className="mt-4">
              {loading ? (
                <span className="text-gray-400">
                  Een moment geduld, de gegevens worden geladen.
                </span>
              ) : (
                "Hier een overzicht van alle Licenties"
              )}
            </p>
          </div>
          {/* Dropdowns with filters */}
          <div className="relative flex-1 flex justify-end" ref={searchRef}>
            {/* Search area */}
            <div className="bg-white w-[50%] h-12 rounded-3xl flex justify-center my-auto border border-gray-200">
              <input
                className="h-6 w-[80%] m-auto focus:outline-none"
                onChange={(e) => setSearchEntry(e.target.value)}
                onFocus={() => setIsSearchFocused(true)}
                value={searchEntry}
                placeholder="Zoeken..."
              />
            </div>

            {/* Filters */}
            {shouldShowFilters && (
              <div className="absolute top-full right-0 z-10 bg-white shadow-lg rounded-lg p-4 border border-gray-200 min-w-[50%] mt-2">
                <b className="text-gray-600 text-xs">Filters</b>
                <div
                  className="text-gray-600 text-sm p-2 cursor-pointer rounded-lg hover:bg-gray-100"
                >
                  <b>Geen specefieke filters mogelijk op het moment</b>
                  <div className="flex text-xs">
                    <b>Zoeken is wel mogelijk</b>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>

        {/* Data Table */}
        <div className="p-8 bg-white  rounded-xl mt-6 w-[80vw] overflow-auto">
          {data.length > 0 && !loading && (
            <div className="w-[132vw] text-gray-600 flex text-sm p-2 border-b-2">
              <div
                className="w-[10vw] flex cursor-pointer select-none"
                onClick={toggleAmountSort}
              >
                <b>Aantal</b>
                {getArrow(amountSort) && (
                  <img
                    src={getArrow(amountSort)!}
                    className="h-5 w-auto ml-1"
                    alt=""
                  />
                )}
              </div>
              <div
                className="w-[20vw] flex cursor-pointer select-none"
                onClick={toggleCustomerSort}
              >
                <b>Naam</b>
                {getArrow(customerSort) && (
                  <img
                    src={getArrow(customerSort)!}
                    className="h-5 w-auto ml-1"
                    alt=""
                  />
                )}
              </div>
              <div
                className="w-[10vw] flex cursor-pointer select-none"
                onClick={toggleVendorSort}
              >
                <b>Uitgever</b>
                {getArrow(vendorSort) && (
                  <img
                    src={getArrow(vendorSort)!}
                    className="h-5 w-auto ml-1"
                    alt=""
                  />
                )}
              </div>
              <div
                className="w-[20vw] flex cursor-pointer select-none"
                onClick={toggleClientSort}
              >
                <b>Klant</b>
                {getArrow(clientSort) && (
                  <img
                    src={getArrow(clientSort)!}
                    className="h-5 w-auto ml-1"
                    alt=""
                  />
                )}
              </div>
              <b className="w-[10vw] text-left">Termijn</b>
              <b className="w-[10vw] text-left">Start</b>
              <b className="w-[10vw] text-left">Eind</b>
              <b className="w-[10vw] text-left">Inkoop p/s</b>
              <b className="w-[10vw] text-left">Verkoop p/s</b>
              <b className="w-[10vw] text-left">Inkoop totaal</b>
              <b className="w-[10vw] text-left">Verkoop totaal</b>
              <b className="w-[10vw] text-left">Margin</b>
            </div>
          )}
          {loading ? (
            <div className="min-w-full bg-gray-200 p-4 font-semibold text-gray-700 dark:text-gray-300 rounded-xl mt-1 animate-pulse">
              <p>Licenties laden...</p>
            </div>
          ) : data.length === 0 ? (
            <tr>
              <td
                colSpan={6}
                className="p-4 text-center text-gray-500 text-xl font-semibold"
              >
                Geen Licenties
              </td>
            </tr>
          ) : (
            getFilteredAndSortedData().map((license, index) => (
              <License
                key={index}
                name={license.name}
                vendor={license.vendor}
                client={license.client}
                term={license.term}
                start={license.start}
                end={license.end}
                Buy_price_per={license.Buy_price_per}
                sell_price_per={license.sell_price_per}
                Buy_price_total={license.Buy_price_total}
                sell_price_total={license.sell_price_total}
                margin={license.margin}
                amount={license.amount}
              />
            ))
          )}
        </div>
      </div>
    </div>
  );
};

export default LicensesLayout;
